const BookPics = {
  1: {
    image: require("./Pictures/House.jpg").default,
    text: "In 1968 my parents bought a small Victorian house in Mendocino",
    alt: "Victorian House",
  },
  2: {
    image: require("./Pictures/Family.jpg").default,
    text: "Our family moved to town and opened a small French cafe (That's me in the back)",
    alt: "Eric Pitsenbarger's Family",
  },
  3: {
    image: require("./Pictures/Restraunt.jpg").default,
    text: "Cafe Beaujolais became a local landmark and helped establish Mendocino as Northern California's capital of cuisine",
    alt: "Cafe Beaujolais",
  },
  4: {
    image: require("./Pictures/CoverFramed.jpg").default,
    text: "",
    alt: "Beaujolais In My Blood - Book Cover",
  },
};

const CalendarImages = [
  {
    full: require("./Pictures/Untitled-Artwork.jpg").default,
    text: "April 25, 2023  6:30-8:00pm story, Q&A and book signing at Book Larder, Seattle, WA",
  },
  {
    full: require("./Pictures/May_9th_2023.jpeg").default,
    text: "May 9, 2023  7:00pm story and Q&A at Third Place Books, Seward Park, Seattle, WA",
  },
  {
    full: require("./Pictures/KelleyHouse.jpg").default,
    text: "May 18, 2023  4:00-5:30pm story and Q&A at Kelley House Museum, Mendocino, CA",
  },
  {
    full: require("./Pictures/May_18_2023_Cafe_Beaujolais.jpg").default,
    text: "May 18, 2023  7:00-8:00pm small plate edibles and story at Cafe Beaujolais, Mendocino, CA",
  },
  {
    full: require("./Pictures/May_20_2023.jpeg").default,
    text: "May 20, 2023  1:00-3:00pm book signing at Gallery Bookshop, Mendocino, CA",
  },
];

const Pictures = [
  {
    thumb: require("./Pictures/YoungGeraldBriefcase400.jpg").default,
    full: require("./Pictures/YoungGeraldBriefcase.jpg").default,
    text: "Twenty-six-year-old Gerald. San Francisco. 1952",
    wide: false,
  },
  {
    thumb: require("./Pictures/Mom400.jpg").default,
    full: require("./Pictures/Mom.jpeg").default,
    text: "Ellen models for I Magnin catalog. San Francisco. 1954.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Crib400.jpg").default,
    full: require("./Pictures/Crib.jpeg").default,
    text: "Baby Eric. San Francisco. 1955.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Drama400.jpg").default,
    full: require("./Pictures/Drama.jpg").default,
    text: "Ellen, baby Greta, Gerald, and Eric at the Greek Theatre. Berkeley. 1960",
    wide: false,
  },
  {
    thumb: require("./Pictures/EricThumb400.jpg").default,
    full: require("./Pictures/Eric.jpg").default,
    text: "Five year-old Eric becomes a princess!",
    wide: false,
  },
  {
    thumb: require("./Pictures/EricStage400.jpg").default,
    full: require("./Pictures/EricStage.jpg").default,
    text: "Eric contemplates a performance. 1963.",
    wide: false,
  },
  {
    thumb: require("./Pictures/VanThumb.jpeg").default,
    full: require("./Pictures/Van.jpeg").default,
    text: "Greta, Eric, and a picnic in the new VW. 1968.",
    wide: true,
  },
  {
    thumb: require("./Pictures/ForSale400.jpg").default,
    full: require("./Pictures/ForSale.jpg").default,
    text: "House for sale. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Mendocino400.jpg").default,
    full: require("./Pictures/Mendocino.jpg").default,
    text: "Mendocino. 2021",
    wide: false,
  },
  {
    thumb: require("./Pictures/CafeSign400.jpg").default,
    full: require("./Pictures/CafeSign.jpeg").default,
    text: "A new café in town. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Foyer400.jpg").default,
    full: require("./Pictures/Foyer.jpg").default,
    text: "Front foyer. Paintings by Jim Bertram. 1972.",
    wide: false,
  },
  {
    thumb: require("./Pictures/DiningRoom400.jpg").default,
    full: require("./Pictures/DiningRoom.jpg").default,
    text: "Front dining room. 1972.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Gerald&EllenKitchen400.jpg").default,
    full: require("./Pictures/Gerald&EllenKitchen.jpg").default,
    text: "Gerald and Ellen hard at work. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/EllenPantry400.jpg").default,
    full: require("./Pictures/EllenPantry.jpg").default,
    text: "Ellen in her pantry. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/We Did it400.jpg").default,
    full: require("./Pictures/We Did it.jpg").default,
    text: "Ellen and Gerald. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/GeraldKitchen400.jpg").default,
    full: require("./Pictures/GeraldKitchen.jpg").default,
    text: "Gerald prepares dinner. 1974.",
    wide: true,
  },
  {
    thumb: require("./Pictures/Gerald&Eric2400.jpg").default,
    full: require("./Pictures/Gerald&Eric2.jpg").default,
    text: "Gerald and Eric sitting at table eight. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/BeaujolaisAd400.jpg").default,
    full: require("./Pictures/BeaujolaisAd.jpg").default,
    text: "First advertisement in the Mendocino Beacon. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/JimBertram400.jpg").default,
    full: require("./Pictures/JimBertram.jpg").default,
    text: "Jim Bertram. 1972.",
    wide: false,
  },
  {
    thumb: require("./Pictures/WaterTower400.jpg").default,
    full: require("./Pictures/WaterTower.jpg").default,
    text: "Water tower. Mendocino. 2021.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Greta2400.jpg").default,
    full: require("./Pictures/Greta2.jpg").default,
    text: "Greta. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/EricSmile400.jpg").default,
    full: require("./Pictures/EricSmile.jpg").default,
    text: "Eric in the foyer. 1971. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Kristin400.jpg").default,
    full: require("./Pictures/Kristin.jpg").default,
    text: "Kristin. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/KristinGretaEric400.jpg").default,
    full: require("./Pictures/KristinGretaEric.jpg").default,
    text: "Kristin, Greta, and Eric in the shed. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/FamilyPortrait400.jpg").default,
    full: require("./Pictures/FamilyPortrait.jpg").default,
    text: "Pitsenbarger family: Eric, Ellen, Kristin, Gerald, and Greta. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/FamilyField400.jpg").default,
    full: require("./Pictures/FamilyField.jpg").default,
    text: "Pitsenbarger family on the Headlands.  Ellen, Kristin, Eric, Greta, and Gerald.  Mendocino.  1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Bench400.jpg").default,
    full: require("./Pictures/Bench400.jpg").default,
    text: "Driftwood bench above Portuguese Beach. Mendocino. 2021.",
    wide: false,
  },
  {
    thumb: require("./Pictures/PromDate400.jpg").default,
    full: require("./Pictures/PromDate.jpg").default,
    text: "Elizabeth and Eric at the prom. 1973.",
    wide: false,
  },
  {
    thumb: require("./Pictures/HandLetteredMenu400.jpg").default,
    full: require("./Pictures/HandLetteredMenu.jpg").default,
    text: "First menu. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/EricEllenGerald400.jpg").default,
    full: require("./Pictures/EricEllenGerald.jpg").default,
    text: "Eric, Ellen, and Gerald on the headlands. Mendocino. 1974.",
    wide: false,
  },
  {
    thumb: require("./Pictures/QueenAnnesLace400.jpg").default,
    full: require("./Pictures/QueenAnnesLace.jpg").default,
    text: "Queen Anne's lace on the headlands. Mendocino. 2021.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Dad&Eric400.jpg").default,
    full: require("./Pictures/Dad&Eric.jpg").default,
    text: "Gerald and Eric.",
    wide: true,
  },
  {
    thumb: require("./Pictures/Siblings400.jpg").default,
    full: require("./Pictures/Siblings.jpg").default,
    text: "Kristin, Eric, and Greta. 1975.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Pitsenbargers400.jpg").default,
    full: require("./Pictures/Pitsenbargers.jpg").default,
    text: "Pitsenbarger family. 1972. © Doug Gieble.",
    wide: false,
  },
  {
    thumb: require("./Pictures/SchoolStreet400.jpg").default,
    full: require("./Pictures/SchoolStreet.jpg").default,
    text: "View from School Street. Mendocino. 1971.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Tureen400.jpg").default,
    full: require("./Pictures/Tureen.jpg").default,
    text: "Ellen's drawing of soup tureen. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/MichaelElliEric400.jpg").default,
    full: require("./Pictures/MichaelElliEric.jpg").default,
    text: "Eleanor, Michael, and Eric. 1976.",
    wide: false,
  },
  {
    thumb: require("./Pictures/Kitchen400.jpg").default,
    full: require("./Pictures/Kitchen.jpeg").default,
    text: "Gerald examines a guest check.",
    wide: false,
  },
  {
    thumb: require("./Pictures/RandomIdeas400.jpg").default,
    full: require("./Pictures/RandomIdeas.jpg").default,
    text: "Ellen and Gerald's notes for improvements to the newly purchased property. 1968.",
    wide: false,
  },
  {
    thumb: require("./Pictures/GeraldandWineThumb400.jpg").default,
    full: require("./Pictures/GeraldandWine.jpg").default,
    text: "Father Gerald with the standard Pitsenbarger “French” lunch.",
    wide: false,
  },
  {
    thumb: require("./Pictures/BowtieThumb400.jpg").default,
    full: require("./Pictures/Bowtie.jpg").default,
    text: "Eric in 2nd grade.",
    wide: false,
  },
  {
    thumb: require("./Pictures/HippyEric400.jpg").default,
    full: require("./Pictures/HippyEric.jpeg").default,
    text: "Seventeen year old Eric poses with toast.",
    wide: true,
  },
  {
    thumb: require("./Pictures/101Nights400.jpg").default,
    full: require("./Pictures/101Nights.jpg").default,
    text: "101 Nights California restaurant guide. 1970.",
    wide: false,
  },
  {
    thumb: require("./Pictures/EricAtBeaujolais400.jpg").default,
    full: require("./Pictures/EricAtBeaujolais.jpg").default,
    text: "At home at the end of Ukiah street.",
    wide: true,
  },
  {
    thumb: require("./Pictures/Sisters400.jpg").default,
    full: require("./Pictures/Sisters.jpeg").default,
    text: "Little sisters Greta and Kristin want to help.",
    wide: true,
  },
];

const DrawingPics = {
  1: {
    thumb: require("./Pictures/Beatnik-Parents.jpg").default,
    full: require("./Pictures/Beatnik-Parents.jpg").default,
    text: "Chapter #1. Waiting For Strange.",
  },
  2: {
    thumb: require("./Pictures/Mercury.jpg").default,
    full: require("./Pictures/Mercury.jpg").default,
    text: "Chapter #2. The Blue Table.",
  },
  3: {
    thumb: require("./Pictures/Red-Rooster.jpg").default,
    full: require("./Pictures/Red-Rooster.jpg").default,
    text: "Chapter #3. The Red Rooster.",
  },
  4: {
    thumb: require("./Pictures/Scroll.jpg").default,
    full: require("./Pictures/Scroll.jpg").default,
    text: "Chapter #5. Petrified Wood.",
  },
  5: {
    thumb: require("./Pictures/MendocinoMap.jpg").default,
    full: require("./Pictures/MendocinoMap.jpg").default,
    text: "End paper. Map of Mendocino walking landmarks.",
  },
  6: {
    thumb: require("./Pictures/Butter.jpg").default,
    full: require("./Pictures/Butter.jpg").default,
    text: "Chapter #15. Glazed Perfection.",
  },
  7: {
    thumb: require("./Pictures/Cafe-Beaujolais.jpg").default,
    full: require("./Pictures/Cafe-Beaujolais.jpg").default,
    text: "End paper. Chapter #11. Café Beaujolais.",
  },
  8: {
    thumb: require("./Pictures/CarpetBag.jpg").default,
    full: require("./Pictures/CarpetBag.jpg").default,
    text: "Chapter #19. Pillow Talk.",
  },
  9: {
    thumb: require("./Pictures/Abalone-Knife.jpg").default,
    full: require("./Pictures/Abalone-Knife.jpg").default,
    text: "Chapter #26. Barnum & Bailey's Colosseum Death Match.",
  },
  10: {
    thumb: require("./Pictures/Driftwood.jpg").default,
    full: require("./Pictures/Driftwood.jpg").default,
    text: "End paper.",
  },
  11: {
    thumb: require("./Pictures/Angel.jpg").default,
    full: require("./Pictures/Angel.jpg").default,
    text: "Chapter #30 Prom Date.",
  },
  12: {
    thumb: require("./Pictures/Hand.jpg").default,
    full: require("./Pictures/Hand.jpg").default,
    text: "Chapter #9. The Haunting.",
  },
  13: {
    thumb: require("./Pictures/La-Fleurette.jpg").default,
    full: require("./Pictures/La-Fleurette.jpg").default,
    text: "End paper. Cheret poster illustration.",
  },
  14: {
    thumb: require("./Pictures/Headlands-Frame.jpg").default,
    full: require("./Pictures/Headlands-Frame.jpg").default,
    text: "Portuguese Beach.",
  },
  15: {
    thumb: require("./Pictures/Hollywood.jpg").default,
    full: require("./Pictures/Hollywood.jpg").default,
    text: "Chapter #29. Accidentally On Purpose.",
  },
  16: {
    thumb: require("./Pictures/Hen.jpg").default,
    full: require("./Pictures/Hen.jpg").default,
    text: "Dedication paper.",
  },
  17: {
    thumb: require("./Pictures/Robot.jpg").default,
    full: require("./Pictures/Robot.jpg").default,
    text: "Chapter #21. Astronaut.",
  },
  18: {
    thumb: require("./Pictures/Shell.jpg").default,
    full: require("./Pictures/Shell.jpg").default,
    text: "End paper",
  },
  19: {
    thumb: require("./Pictures/Weeds.jpg").default,
    full: require("./Pictures/Weeds.jpg").default,
    text: "End paper.",
  },
  20: {
    thumb: require("./Pictures/Singer Sewing Machine.jpg").default,
    full: require("./Pictures/Singer Sewing Machine.jpg").default,
    text: "Chapter #20. Rattling the Chandeliers.",
  },
  21: {
    thumb: require("./Pictures/Water-TowerFrame.jpg").default,
    full: require("./Pictures/Water-TowerFrame.jpg").default,
    text: "Water tower.",
  },
  22: {
    thumb: require("./Pictures/DunwichHorror.jpg").default,
    full: require("./Pictures/DunwichHorror.jpg").default,
    text: "Chapter #23. The Dunwich Horror.",
  },
  23: {
    thumb: require("./Pictures/Wine Bottle.jpg").default,
    full: require("./Pictures/Wine Bottle.jpg").default,
    text: "Chapter #11. Café Beaujolais.",
  },
  24: {
    thumb: require("./Pictures/Menu-Cover.jpg").default,
    full: require("./Pictures/Menu-Cover.jpg").default,
    text: "Recreation of original menu illustration.",
  },
  25: {
    thumb: require("./Pictures/Cover-Idea.jpg").default,
    full: require("./Pictures/Cover-Idea.jpg").default,
    text: "First cover treatment.",
  },
  26: {
    thumb: require("./Pictures/Cover.jpg").default,
    full: require("./Pictures/Cover.jpg").default,
    text: "Beaujolais in My Blood.",
  },
};

export { Pictures, DrawingPics, BookPics, CalendarImages };
